import React, { useState, useEffect, useRef } from "react";

export default function HoliosComponent() {
  const [sessionId, setSessionId] = useState("");
  const [requestId, setRequestId] = useState("");
  const [query, setQuery] = useState("");
  const [chatHistory, setChatHistory] = useState([]);
  const [isTyping, setIsTyping] = useState(false); // For blinking dots

  const chatEndRef = useRef(null);

  // Auto-scroll to bottom whenever chatHistory changes
  useEffect(() => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [chatHistory, isTyping]);

  // Generate session_id once when page loads
  useEffect(() => {
    const storedId = localStorage.getItem("session_id");
    if (storedId) {
      setSessionId(storedId);
    } else {
      const newId = Math.floor(Math.random() * 100000000).toString();
      localStorage.setItem("session_id", newId);
      setSessionId(newId);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!requestId || !query) {
      alert("Please enter both Request ID and Query!");
      return;
    }

    const reqBody = {
      session_id: sessionId,
      request_id: requestId,
      query: query,
    };

    const userMessage = query;
    setQuery("");

    // Add user query to chat immediately
    setChatHistory((prev) => [...prev, { type: "user", text: userMessage }]);

    // Show typing indicator
    setIsTyping(true);

    try {
      const response = await fetch(
        "https://n8n.doclift.ai/webhook/2680ae31-9e25-4f97-ad3d-1915079ed767",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(reqBody),
        }
      );

      let resultText = "";
      const textData = await response.text();

      try {
        const json = JSON.parse(textData);
        resultText =
          typeof json === "string"
            ? json
            : json.response || JSON.stringify(json, null, 2);
      } catch {
        resultText = textData;
      }

      // Add bot response to chat
      setChatHistory((prev) => [...prev, { type: "bot", text: resultText }]);
    } catch (error) {
      setChatHistory((prev) => [
        ...prev,
        { type: "bot", text: "Error: " + error.message },
      ]);
    } finally {
      setIsTyping(false);
    }
  };

  return (
    <div className="flex flex-col h-screen p-4 border border-gray-400 mt-16">
      {/* Chat Display */}
      <div className="flex-1 border border-gray-400 p-4 overflow-y-auto rounded bg-gray-50">
        {chatHistory.length > 0 ? (
          chatHistory.map((msg, index) => (
            <div
              key={index}
              className={`my-2 p-2 rounded-lg max-w-[80%] ${
                msg.type === "user"
                  ? "bg-blue-100 self-end text-right ml-auto"
                  : "bg-gray-200 self-start text-left"
              }`}
            >
              <pre className="whitespace-pre-wrap text-sm">{msg.text}</pre>
            </div>
          ))
        ) : (
          <p className="text-center text-gray-500">
            Chat messages will appear here
          </p>
        )}

        {/* Typing indicator */}
        {isTyping && (
          <div className="my-2 p-2 rounded-lg max-w-[20%] bg-gray-200 self-start text-left animate-pulse">
            <span className="text-xl">•</span>
            <span className="text-xl">•</span>
            <span className="text-xl">•</span>
          </div>
        )}

        <div ref={chatEndRef} />
      </div>

      {/* Input Form */}
      <form
        onSubmit={handleSubmit}
        className="mt-4 bg-white border-t border-gray-300 pt-4 sticky bottom-0"
      >
        <div className="mb-2 flex items-center gap-2">
          <label className="w-16">Req ID</label>
          <input
            type="text"
            value={requestId}
            onChange={(e) => setRequestId(e.target.value)}
            className="border border-gray-400 p-2 flex-1 rounded"
            placeholder="Enter Request ID"
          />
        </div>

        <div className="mb-2 flex items-center gap-2">
          <label className="w-16">Query</label>
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            className="border border-gray-400 p-2 flex-1 rounded"
            placeholder="Enter Query"
          />
        </div>

        <div className="flex justify-center mb-10 mt-5">
          <button
            type="submit"
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  );
}
